<div class="comment" [ngClass]="{ 'comment--reply-mode': isReplay() }">
  <div class="comment__header">
    <!-- comment profile -->
    <div class="comment-user">
      <img
        class="comment-user__img"
        [ngSrc]="
          comment()?.user?.profile_image?.cropped_thumbnail ||
            comment()?.user?.profile_image?.cropped_url
            | imageSource: false : 'sm' : 'assets/images/no-profile-image.png'
        "
        width="58"
        height="58"
        alt="" />
      <div class="comment-user__content">
        <h4 class="username">
          {{ comment()?.user?.first_name }} {{ comment()?.user?.last_name }}
        </h4>
        <p class="user-role">
          {{ comment()?.user?.job_position | translateData }}
        </p>
      </div>
    </div>

    <p class="comment-date">
      {{ comment()?.created_at | date: 'EEE MMM d y' }}
    </p>
  </div>

  <div class="comment__content">
    <p class="comment-text">
      {{ comment()?.text | translateData }}
    </p>
  </div>

  <div class="comment__footer">
    <button class="comment-action" type="button" (click)="onReplay()">
      <i class="iconsax" icon-name="message-dash-1"></i>
      <span>{{ 'global.replay' | translate }}</span>
    </button>

    <button class="comment-action" type="button" (click)="onReport()">
      <i class="iconsax" icon-name="info-circle"></i>
      <span>{{ 'reportComment.action' | translate }}</span>
    </button>
  </div>
</div>
